import React, { Component } from "react";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageLaHaye_1 from "../images/realisations/projet_tribunal-la-haye/01_Eurojust_tribunal_dela_Haye.jpg";
import ImageLaHaye_2 from "../images/realisations/projet_tribunal-la-haye/02_Eurojust_tribunal_dela_Haye.jpg";
import ImageLaHaye_3 from "../images/realisations/projet_tribunal-la-haye/03_Eurojust_tribunal_dela_Haye.jpg";
import ImageLaHaye_4 from "../images/realisations/projet_tribunal-la-haye/04_Eurojust_tribunal_dela_Haye.jpg";
import ImageLaHaye_5 from "../images/realisations/projet_tribunal-la-haye/05_Eurojust_tribunal_dela_Haye.jpg";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";


class RealisationEurojustLaHaye extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="grid grid--2 grid--fixed"
          style={{ marginTop: "55px" }}
        >
          <LocalizedLink className="grid__item" to="/realisations">
            <div className="grid__item-title">
              <i className="f7 i-arrow-left-light" /> {this.props.t("common:realisationsBackbutton")}
            </div>
          </LocalizedLink>
          <div className="grid__item">
            <div className="grid__item-title-nohover font-bold">Eurojust - La Haye</div>
          </div>
        </section>

        <section className="projects">
          <div
            className="projects__item projects__item--100"
            style={{ backgroundImage: `url(${ImageLaHaye_1})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Mecanoo Architecten
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageLaHaye_2})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Mecanoo Architecten
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageLaHaye_3})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Mecanoo Architecten
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageLaHaye_4})` }}
          >
            <div className="projects__item-label">
            {this.props.t("common:labelSurface")} : Oberflex - {surfacesByIds[29]["title_"+this.props.lng]} {/*Oberflex - Frêne FR 101*/}
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageLaHaye_5})` }}
          >
            <div className="projects__item-label">
            {this.props.t("common:labelPattern")} : {this.props.t("common:labelCollections55")} - {patternsByIds[32]["title_"+this.props.lng]}{" "}{/* Collections 5.5 - Onde*/}
          </div>
          </div>
        </section>

        <section className="w-100 pv7">
          <div className="w-100 tc">

          <LocalizedLink className="button button--large" to="/realisations/institution-internationale">
            <i className="button__icon i-arrow-left-light" />
            &nbsp;{this.props.t('common:labelPreviousProject')}
          </LocalizedLink>

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <LocalizedLink className="button button--large" to="/create">
          {this.props.t('common:labelCreateYourModel')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>


          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <LocalizedLink className="button button--large" to="/realisations/mcdonalds-champs-elysees">
            {this.props.t('common:labelNextProject')}&nbsp;
            <i className="button__icon i-arrow-right-light" />
          </LocalizedLink>

          </div>
        </section>

          <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default RealisationEurojustLaHaye;



// WEBPACK FOOTER //
// ./src/components/RealisationEurojustLaHaye.js